import classNames from 'classnames/bind';
import React from 'react';
import { useDispatch } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import EmptyList from '@/components/ui/EmptyList';
import { MissionLoad } from '@/define/commandSet/mavlink';

const cx = classNames.bind(styles);

const Empty = () => {
  const dispatch = useDispatch();

  const toggleCommand = () => {
    dispatch(actions.command.toggleSidebar(MissionLoad.id));
  };

  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>Commands</div>
      </div>
      <div className={cx('body')}>
        <div className={cx('empty')}>
          <EmptyList message="No mission loaded" />
          <button type="button" className={cx('button')} onClick={toggleCommand}>
            Load
          </button>
        </div>
      </div>
    </div>
  );
};

export default Empty;
